import tippy from 'tippy.js';

// $(function () {
//     let chapterIndex = 0
//     $('.chapter').each(function () {
//         const $chapter = $(this);
//         chapterIndex++;
//
//         let index = 0;
//         $chapter.find('.fnoteWrap').each(function () {
//             const $fnote = $(this);
//             index++;
//
//             const content = $fnote.find('.fnoteBtn').attr('data-content');
//
//             // const btnEl = `<a href="#footnote-content-` + index + `"><sup>` + index + `</sup></a>`;
//             const btnEl = `<a href="#chapter-${chapterIndex}-footnote-content-${index}" class="footnotes-button"><sup>${index}</sup></a>`;
//             const footnoteEl = `
//             <div class="footnote" id="chapter-${chapterIndex}-footnote-content-${index}">
//                 <sup class="index">${index}</sup>
//                 <span>${decodeURIComponent(content)}</span>
//             </span>
//         `;
//             $fnote.html(btnEl)
//             $chapter.find('.footnotes').append(footnoteEl);
//
//         });
//
//         if ($chapter.find('.fnoteWrap').length === 0) {
//             $chapter.find('.footnotes-container').hide();
//         }
//     });
//
//     $(document).on('click', '.footnotes-button', function (e) {
//         e.preventDefault();
//         const href = $(this).attr('href');
//         console.log(href);
//         $('html, body').animate({
//             scrollTop: $(href).offset().top - 100
//         }, 500);
//     })
//
// });


$(function () {
    let index = 0;
    $('.fnoteWrap').each(function () {
        index++;
        const $this = $(this);
        let content = $(this).find('.fnoteBtn').attr('data-content');

        const btnEl = `
            <a href="#" class="footnotes-button" data-index="${index}" data-content="${content}">
                ${index}
            </a>
        `;
        $this.html(btnEl)
    });

    tippy('.footnotes-button', {
        content(reference) {
            return replaceURLs(decodeURIComponent(reference.getAttribute('data-content')));
        },
        allowHTML: true,
        trigger: 'click',
        interactive: true,
    });


    function replaceURLs(message) {
        if(!message) return;

        var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
        return message.replace(urlRegex, function (url) {
            var hyperlink = url;
            if (!hyperlink.match('^https?:\/\/')) {
                hyperlink = 'http://' + hyperlink;
            }
            return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
        });
    }

    $(document).on('click', '.footnotes-button', function (e) {
        e.preventDefault();
    })
});

